<template>
  <div class="row">
    <div class="login">
      <div class="col-12">
        <center><h6>QUÊN MẬT KHẨU</h6></center>
        <div class="mt-4"><p>Nhập số điện thoại để cấp lại mật khẩu</p></div>
        <form
          class="mt-3">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Số điện thoại">
          </div>
          <button
            type="button"
            class="btn btn-order bg-green"
            @click="forgotPassword">Tiếp tục
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import {errorToaster} from '../../services/ErrorHandler'

  export default {
    name: 'ForgotPassword',
    data () {
      return {
        phone: ''
      }
    },

    mounted () {
      this.phone = ''
    },

    methods: {
      forgotPassword () {
        rf.getRequest('UserRequest').forgotPassword({
          phone: this.phone
        }).then((res) => {
          if (res.status === 200) {
            this.$router.push({path: '/otp', params: {phone: this.phone}})
          } else {
            errorToaster('Cố vấn phong thủy', res.message)
          }
        }).catch(err => {
          errorToaster('Cố vấn phong thủy', 'Xảy ra lỗi kết nối')
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/ForgotPassword.vue